import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        manualsPageContainer: {
            width: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'background.default',
        },
        pageInnerContainer: {
            width: '100%',
            layerStyle: 'full-width',
            flexDirection: 'column',
            padding: {base: `0 ${remCalc(16)}`, xl: 'unset'},
        },
        breadcrumbContainer: {margin: {base: `${remCalc(40)} 0`, lg: `0 0 ${remCalc(80)} 0`}},
        goBackButtonContainer: {marginBottom: 'medium.md'},
        goBackButton: {
            variant: 'text-button',
            textDecoration: 'unset',
        },
        headerContentContainer: {
            flexDirection: 'column',
            gap: 'medium.base',
            marginBottom: {base: 'large.base', lg: 'large.lg'},
        },
        manualsDivider: {color: 'background.grey'},
        headerTitle: {textStyle: 'head-medium', fontWeight: '500'},
        headerSubtitle: {
            color: 'text.default',
            textStyle: 'head-xsmall',
            fontWeight: '500',
            my: 'small.base',
        },
        headerFindProductNumberLabel: {
            cursor: 'pointer',
            textStyle: 'body-xxsmall',
            fontWeight: '400',
            textDecoration: 'underline',
        },
        headerDivider: {
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.dark',
        },
        manualsModalContent: {
            width: '100%',
            maxW: remCalc(688),
        },
        modalInstructionsContainer: {
            flexDirection: 'column',
            textStyle: 'body-small',
            fontWeight: '400',
            gap: 'small.base',
            marginBottom: 'medium.base',
        },
        manualsModalBody: {
            padding: {
                base: `0 ${remCalc(24)} ${remCalc(80)}`,
                lg: `0 ${remCalc(24)} ${remCalc(40)}`,
            },
        },
        manualsModalHeader: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'small.base',
            padding: {
                base: `${remCalc(80)} ${remCalc(24)} ${remCalc(16)}`,
                lg: `${remCalc(40)} ${remCalc(24)} ${remCalc(16)}`,
            },
        },
        manualsModalTitle: {
            textStyle: 'body-large',
            fontWeight: '400',
            color: 'text.default',
        },
        noResultsText: {
            textStyle: 'body-medium',
            fontWeight: '400',
            color: 'text.tertiary',
        },
    },
}
